import * as admin from './admin'
export default {
    admin
}
